/**
 * Synchronous WebGL feature-detect.
 *
 * Returns true if the browser can create a WebGL context (WebGL1 or WebGL2).
 * Returns false inside Facebook / Instagram / TikTok Android WebViews that
 * disable WebGL, on very old iOS Safari builds, and on devices where
 * hardware acceleration has been disabled. Catches the exact error that
 * surfaces in Clarity as "THREE.WebGLRenderer: Error creating WebGL context."
 *
 * Caches the result on first call so repeated mounts don't thrash the GPU.
 */

let _cached = null;

export default function hasWebGL() {
  if (_cached !== null) return _cached;
  if (typeof document === "undefined") return (_cached = false);
  try {
    const c = document.createElement("canvas");
    const gl = c.getContext("webgl2") || c.getContext("webgl") || c.getContext("experimental-webgl");
    _cached = !!(gl && typeof gl.getParameter === "function");
    // Explicitly drop the context so we don't leak a hidden GPU slot.
    try { gl?.getExtension?.("WEBGL_lose_context")?.loseContext?.(); } catch {}
    return _cached;
  } catch {
    _cached = false;
    return _cached;
  }
}
